<template>
  <div :style="{backgroundColor: config.backgroundColor, height: '100%'}">

    <Loading
      :show="loading"
      :label="loadingLabel">
    </Loading>


    <div class="hero" :style="heroStyle"></div>

    <div class="btn-group btn-group-justified btn-nav" role="group" aria-label="Justified button group">
      <a class="btn" :style="btnConfigStyle('CompanyHistory')" @click="activeComponent='CompanyHistory'">
        <span :style="clickIconStyle" v-show="activeComponent === 'CompanyHistory'"></span> OL History
      </a>
      <a class="btn" :style="btnConfigStyle('CompanyTransactions')" @click="activeComponent='CompanyTransactions'">
        <span :style="clickIconStyle" v-show="activeComponent === 'CompanyTransactions'"></span> DA Transactions
      </a>
      <a class="btn" :style="btnConfigStyle('CompanyPriceAudit')" @click="activeComponent = 'CompanyPriceAudit'">
        <span :style="clickIconStyle" v-show="activeComponent === 'CompanyPriceAudit'"></span> Price Audit
      </a>
      <a class="btn" :style="btnConfigStyle('CompanySummary')">
        <span :style="clickIconStyle" v-show="activeComponent === 'CompanySummary'"></span> Today's Summary
      </a>
      <a class="btn" :style="btnConfigStyle('CompanyTriggers')">
        <span :style="clickIconStyle" v-show="activeComponent === 'CompanyTriggers'"></span> Triggers
      </a>
    </div>

    <div class="container-fluid">
      <keep-alive>
        <component :is="activeComponent" :config="config" :companyId="companyId" :accessToken="accessToken"></component>
      </keep-alive>
    </div>
  </div>


  <!--<b-row>-->

  <!--<div v-if="loading">-->
  <!--Loading Data...-->
  <!--</div>-->

  <!--<b-col md="12" sm="12" lg="sm" v-if="histories" :class="companyClass" class="animated fadeIn bg-container"-->
  <!--:style="{backgroundImage: `url('${this.companyBg}')`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'top'}">-->


  <!--<b-card-group class="mb-4">-->

  <!--<b-card @click="viewingStoreNumTable = !viewingStoreNumTable">-->
  <!--<div class="h1 text-muted text-right mb-4">-->
  <!--<i class="icon-basket-loaded"></i>-->
  <!--</div>-->
  <!--<div class="h4 mb-0">{{ storeNumbers.length }}</div>-->
  <!--<small class="text-muted text-uppercase font-weight-bold">Stores Refreshed</small>-->
  <!--<b-progress height={} class="progress-xs mt-3 mb-0" variant="warning"-->
  <!--:value="storeNumbers.length * 100 / 100"/>-->
  <!--</b-card>-->

  <!--<b-card>-->
  <!--<div class="h1 text-muted text-right mb-4">-->
  <!--<i class="icon-pie-chart"></i>-->
  <!--</div>-->
  <!--<div class="h4 mb-0">{{ successPercentage }}%</div>-->
  <!--<small class="text-muted text-uppercase font-weight-bold">Success Rate</small>-->
  <!--<b-progress height={} class="progress-xs mt-3 mb-0" :value="parseFloat(successPercentage)"/>-->
  <!--</b-card>-->

  <!--<b-card>-->
  <!--<div class="h1 text-muted text-right mb-4">-->
  <!--<i class="icon-speedometer"></i>-->
  <!--</div>-->
  <!--<div class="h4 mb-0">{{ avgTime }}</div>-->
  <!--<small class="text-muted text-uppercase font-weight-bold">Avg. Time Per Refresh</small>-->
  <!--<b-progress height={} class="progress-xs mt-3 mb-0" variant="danger" :value="25"/>-->
  <!--</b-card>-->
  <!--</b-card-group>-->

  <!--<b-col sm="12" md="12" lg="12">-->
  <!--</b-col>-->

  <!--<b-col sm="12" md="12" lg="12">-->
  <!--<c-table-->
  <!--v-show="viewingStoreNumTable"-->
  <!--:caption="'Success Store Refresh History'"-->
  <!--:refreshes="successHistoryTableData"-->
  <!--:fields="successFields"-->
  <!--:hover="true">-->
  <!--</c-table>-->
  <!--</b-col>-->

  <!--</b-col>-->

  <!--</b-row>-->
</template>

<script>
  import store from './store';
  import Loading from 'vue-full-loading';

  import SSR from './ssr';
  import RequirePersonAuth from './PersonAuth';

  import CompanyHistory from './CompanyHistory';
  import CompanyPriceAudit from './CompanyPriceAudit';
  import CompanyTransactions from './CompanyTransactions';


  export default {
    name: "CompanyDashboard",
    mixins: [RequirePersonAuth, SSR],
    components: {Loading, CompanyHistory, CompanyTransactions, CompanyPriceAudit},


    data() {
      return {
        store: store,
        state: store.state,

        loading: true,
        loadingLabel: "Loading Company Data...",

        config: {},
        accessToken: '',
        activeComponent: 'CompanyHistory',
      }
    },

    created() {
      this.getBaseUrls()
        .then(() => {

          let config = this.store.getCompanyConfig(this.companyId);
          let accessToken = this.store.getCompanyAccessToken(this.companyId);

          if (config && accessToken) {
            this.config = config;
            this.accessToken = accessToken;
            this.loading = false;
            return
          }

          if (!accessToken) {


            this.getCompanyIdAccessToken(this.companyId).then(res => {


              this.store.setCompanyIdAccessToken(this.companyId, res.body);
              this.accessToken = res.body;

              this.getCompanyUIConfig(this.companyId, res.body).then(res => {
                let config = {
                  companyId: this.companyId,
                  logo: res.body.logo,
                  headerImg: res.body.header_img,
                  clickIcon: res.body.click_icon,
                  primaryColor: res.body.primary_color,
                  secondaryColor: res.body.secondary_color,
                  backgroundColor: res.body.background_color
                };


                this.store.setCompanyConfig(this.companyId, config);
                this.config = config;

              }, err => {
                console.log(err);
              }).then(() => {
                this.loading = false;
              })

            }, err => {
              console.log(err);
            });

          } else {
            this.accessToken = accessToken;

            this.getCompanyUIConfig(this.companyId, accessToken).then(res => {

              let config = {
                companyId: this.companyId,
                logo: res.body.logo,
                headerImg: res.body.header_img,
                clickIcon: res.body.click_icon,
                primaryColor: res.body.primary_color,
                secondaryColor: res.body.secondary_color,
                backgroundColor: res.body.background_color
              };

              this.store.setCompanyConfig(this.companyId, config);
              this.config = config;

            }, err => {
              console.log(err);
            }).then(() => {
              this.loading = false;
            })
          }
        })
    },

    computed: {
      personToken() {
        return this.state.personToken
      },

      companyId() {
        return this.$route.params.id;
      },

      heroStyle() {
        return {
          height: '275px',
          borderBottom: '2px solid',
          borderBottomColor: this.config.primaryColor,
          backgroundImage: `url(${this.config.headerImg})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center'
        }
      },

      clickIconStyle() {
        return {
          backgroundImage: `url(${this.config.clickIcon})`,
          height: '25px',
          width: '25px',
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          verticalAlign: 'inherit',
          display: 'inline-block',
          marginRight: '5px'
        }
      }
    },

    methods: {
      btnConfigStyle(componentName) {
        let styles = {
          backgroundColor: this.config.backgroundColor,
          borderColor: 'transparent',
          color: this.config.secondaryColor,
          borderBottom: `2px solid ${this.config.secondaryColor}`
        };

        if (componentName === this.activeComponent) {
        }

        return styles;
      },

      getCompanyIdAccessToken(companyId) {
        return this.$http.post(`${this.portalBaseURL}/me/access-token`, {company_id: companyId}, {
          headers: {
            Authorization: `Bearer ${this.personToken}`
          }
        })
      },

      getCompanyUIConfig(companyId, accessToken) {
        return this.$http.get(`${this.olBaseURL}/companies/${companyId}/ui-config`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          }
        })
      },
    }
  }

  // export default {
  //
  //   components: {cTable},
  //
  //   data() {
  //     return {
  //       store: store,
  //       loading: true,
  //       transData: [],
  //       historyData: [],
  //       state: store.state,
  //       failureIds: new Set(),
  //       viewingStoreNumTable: false,
  //       failureFields: [
  //         {key: 'storeNum'},
  //         {key: 'date'},
  //         {key: 'status'},
  //         {key: 'exceptionMessage'}
  //       ],
  //       successFields: [
  //         {key: 'storeNum'},
  //         {key: 'date'},
  //         {key: 'status'},
  //       ],
  //     }
  //   },
  //
  //   created() {
  //     this.getHistory();
  //     this.getTransactions();
  //   },
  //
  //   methods: {
  //
  //     getTransactions() {
  //       let options = {
  //         params: {
  //           from_date: moment().subtract(60, "days").format(),
  //           to_date: moment().format()
  //         },
  //
  //         headers: {
  //           "Content-Type": "application/json",
  //           "Authorization": `Bearer ${this.token}`,
  //           'X-Company-Id': this.companyId
  //         }
  //       };
  //
  //
  //       this.$http.get(`${this.olBaseUrl}/transactions`, options)
  //         .then(res => {
  //           this.transData = res.data.data;
  //           this.loading = false;
  //         }, err => {
  //           console.log(err);
  //         })
  //
  //     },
  //
  //     getHistory() {
  //
  //       let options = {
  //         params: {
  //           days_ago: 31,
  //         },
  //
  //         headers: {
  //           "Content-Type": "application/json",
  //           "Authorization": `Bearer ${this.token}`,
  //           'X-Company-Id': this.companyId
  //         }
  //       };
  //
  //
  //       this.$http.get(`${this.olBaseUrl}/history`, options)
  //         .then(res => {
  //           this.historyData = res.data.items;
  //           this.loading = false;
  //         }, err => {
  //           console.log(err);
  //         })
  //
  //     },
  //   },
  //
  //   computed: {
  //     companyId() {
  //       return this.$route.params.company_id;
  //     },
  //
  //     companyName() {
  //       return this.store.getCompanyName(this.companyId);
  //     },
  //
  //     companyHeader() {
  //       return this.store.getCompanyHeader(this.companyId);
  //     },
  //
  //     companyBg() {
  //       return this.store.getCompanyBg(this.companyId);
  //     },
  //
  //     companyClass() {
  //       return this.store.getCompanyClass(this.companyId);
  //     },
  //
  //     histories() {
  //       return this.historyData;
  //     },
  //
  //     storeNumbers() {
  //       if (this.histories.length > 0) {
  //         let uniqueStoreNums = new Set();
  //
  //         this.histories.forEach(hist => {
  //           uniqueStoreNums.add(hist.store_number);
  //         });
  //
  //         return Array.from(uniqueStoreNums)
  //       }
  //
  //     },
  //
  //     avgTime() {
  //
  //       if (this.histories.length > 0) {
  //         let total_elapsed = 0;
  //
  //         this.histories.forEach(hist => {
  //
  //           total_elapsed += hist.time_to_create_data;
  //           total_elapsed += hist.time_to_delete_data;
  //           total_elapsed += hist.time_to_extract_data;
  //           total_elapsed += hist.time_to_load_data;
  //           total_elapsed += hist.time_to_transform_data;
  //           total_elapsed += hist.time_to_validate_data;
  //         });
  //
  //         return `${(total_elapsed / this.histories.length).toFixed(2)} Seconds`;
  //       }
  //     },
  //
  //     successPercentage() {
  //       if (this.histories.length > 0) {
  //         let failures = new Set();
  //         let successes = new Set();
  //
  //         this.histories.forEach(hist => {
  //           let status = hist.status;
  //
  //           if (status === 'success') {
  //             successes.add(hist.store_number);
  //           }
  //
  //           if (status === 'failure') {
  //             failures.add(hist.store_number)
  //           }
  //         });
  //
  //
  //         // Now we need to remove stores that failed that are in the success.
  //         successes.forEach(storeNum => {
  //           if (failures.has(storeNum)) {
  //             failures.delete(storeNum)
  //           }
  //         });
  //
  //         return (100 - (100 * failures.size / successes.size)).toFixed(2);
  //       }
  //     },
  //
  //     successHistories() {
  //
  //       if (this.histories.length > 0) {
  //         let successes = [];
  //
  //         this.histories.forEach(hist => {
  //           let status = hist.status;
  //
  //           if (status === 'success') {
  //             successes.push(hist);
  //           }
  //         });
  //
  //         return successes;
  //       }
  //     },
  //
  //     successHistoryTableData() {
  //       if (this.successHistories && this.successHistories.length > 0) {
  //         return this.successHistories.map(hist => {
  //           return {
  //             storeNum: hist.store_number,
  //             date: moment.utc(hist.start_time).format('dddd, MMMM Do, h a'),
  //             status: hist.status,
  //           }
  //         })
  //       }
  //     },
  //
  //     failureHistories() {
  //       if (this.histories.length > 0) {
  //         let failures = [];
  //         let storeFailureMap = {};
  //
  //         this.histories.forEach(hist => {
  //           let status = hist.status;
  //           let storeNum = hist.store_number;
  //
  //           if (status === 'success') {
  //             delete storeFailureMap[storeNum]
  //           }
  //
  //           if (status === 'failure') {
  //
  //             if (storeNum in storeFailureMap) {
  //               storeFailureMap[storeNum].push(hist.id)
  //             } else {
  //               storeFailureMap[storeNum] = [];
  //               storeFailureMap[storeNum].push(hist.id)
  //             }
  //           }
  //         });
  //
  //         Object.values(storeFailureMap).forEach(historyIds => {
  //           historyIds.forEach(id => {
  //             let history = this.histories.filter(hist => hist.id === id);
  //             failures.push(history[0]);
  //           })
  //         });
  //
  //         return failures;
  //       }
  //     },
  //
  //     failureHistoryTableData() {
  //       if (this.failureHistories.length > 0) {
  //
  //         return this.failureHistories.map(hist => {
  //           return {
  //             storeNum: hist.store_number,
  //             date: moment.utc(hist.start_time).format('dddd, MMMM Do, h a'),
  //             status: hist.status,
  //             exceptionMessage: hist.exception_message ? hist.exception_message : 'None'
  //           }
  //         })
  //       }
  //     },
  //
  //
  //     refreshesTableData() {
  //
  //       if (this.histories.length > 0) {
  //
  //         let refreshes = [];
  //
  //         this.histories.forEach(hist => {
  //           refreshes.push(
  //             {
  //               storeNum: hist.store_number,
  //               date: moment.utc(hist.start_time).format('dddd, MMMM Do, h a'),
  //               status: hist.status,
  //               exceptionMessage: hist.exception_message ? hist.exception_message : 'None'
  //             }
  //           )
  //         });
  //
  //         refreshes = refreshes.sort((a, b) => {
  //           let aDate = moment(a, 'dddd, MMMM Do, h a');
  //           let bDate = moment(b, 'dddd, MMMM Do, h a');
  //
  //           if (aDate.isAfter(bDate)) {
  //             return 1
  //           } else {
  //             return -1
  //           }
  //         });
  //
  //         return refreshes;
  //       }
  //     },
  //
  //     failureTableData() {
  //       if (this.histories.length > 0) {
  //         let data = [];
  //       }
  //     },
  //
  //     token() {
  //       return this.store.getToken()
  //     },
  //
  //     olBaseUrl() {
  //       return this.store.getOlBaseUrl();
  //     }
  //   }
  // }
</script>

<style scoped lang="scss">

  .btn-group-justified {
    display: flex;
    width: 100%;

    .btn,
    .btn-group {
      flex: 1;

      .btn {
        width: 100%;
      }

      .dropdown-menu {
        left: auto;
      }

    }
  }

  .btn-nav {
    margin-bottom: 25px;
  }
</style>
